<div *ngIf="iShowDrivingEvents">
  <table class="table driving-table">
    <thead>
    <tr>
      <th scope="col" *ngIf="!iNavMobile && iShowStudent">#</th>
      <th scope="col" class="driving-col-date">Date et heure</th>
      <th scope="col" class="driving-col-monitor">Moniteur</th>
      <th scope="col" class="driving-col-type">Type</th>
    </tr>
    </thead>
    <tbody>
    <tr *ngFor="let d of iDrivingEvents" [ngClass]="isConsumed(d.start) ? 'event-consumed' : 'event-reserved'">
      <th scope="row" *ngIf="!iNavMobile && iShowStudent">{{d.id}}</th>
      <td>{{d.start | date:'dd/MM/YYYY HH:mm'}}</td>
      <td class="driving-col-monitor">{{d.extendedProps.monitor.firstname}}</td>
      <td class="driving-col-type">
        <span class="driving-type-badge" [ngClass]="d.extendedProps.boxType == 'AUTOMATIQUE' ? 'driving-type-badge--automatic' : 'driving-type-badge--manual'">
          {{ getBoxTypeLabel(d.extendedProps.boxType) }}
        </span>
      </td>
    </tr>
    </tbody>
  </table>

  <app-pagination *ngIf="iPageDrivingEvent" [iEmpty]="iPageDrivingEvent.empty" [iFirst]="iPageDrivingEvent.first"
                  [iLast]="iPageDrivingEvent.last" [iNumber]="iPageDrivingEvent.number" [iTotalPages]="iPageDrivingEvent.totalPages"
                  [iPageSize]="iPageDrivingEvent.size"
                  (currentPageChanged)="onChangeConsumptionPage($event)" >
  </app-pagination>
</div>
